/**
 * Maps an AI-generated meal draft (AiMealDraftDTO from /api/meals/ai-parse,
 * or one entry of AiMealSuggestionDTO[] from /api/meals/suggest) into
 * UserMealForm's local form state shape.
 */
export const mapAiDraftToForm = (draft, ingredientUnits) => ({
  mealName: draft.mealName || "",
  mealCategories: {
    breakfast: !!draft.breakfast,
    lunch: !!draft.lunch,
    dinner: !!draft.dinner,
    snack: !!draft.snack,
  },
  mealTagList: draft.mealTagList || [],
  timeMins: draft.timeMins != null ? String(draft.timeMins) : "",
  servings: draft.servings != null ? String(draft.servings) : "",
  ingredients:
    draft.ingredients && draft.ingredients.length > 0
      ? draft.ingredients.map((ing) => ({
          id: crypto.randomUUID(),
          name: ing.name || "",
          quantity: ing.quantity != null ? String(ing.quantity) : "",
          unit: ing.unit || ingredientUnits?.[0] || "",
        }))
      : [
          {
            id: crypto.randomUUID(),
            name: "",
            quantity: "",
            unit: ingredientUnits?.[0] || "",
          },
        ],
});
